"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractSelectorMessages = void 0;

var _reactIntl = require("react-intl");

var contractSelectorMessages = (0, _reactIntl.defineMessages)({
  revision: {
    id: 'contractSelectorMessages.revision',
    description: 'Revision text.',
    defaultMessage: 'Revision'
  },
  contractDetails: {
    id: 'contractSelectorMessages.contractDetails',
    description: 'Contract details text.',
    defaultMessage: 'Contract Details'
  },
  items: {
    id: 'contractSelectorMessages.items',
    description: 'Items text',
    defaultMessage: 'Items'
  },
  lastModified: {
    id: 'contractSelectorMessages.lastModified',
    description: 'Last modified text.',
    defaultMessage: 'Last Modified'
  },
  lastModifiedBy: {
    id: 'contractSelectorMessages.lastModifiedBy',
    description: 'Last modified by text.',
    defaultMessage: 'Last Modified By'
  },
  discount: {
    id: 'contractSelectorMessages.discount',
    description: 'Discount text.',
    defaultMessage: 'Discount'
  },
  markup: {
    id: 'contractSelectorMessages.markup',
    description: 'Markup text.',
    defaultMessage: 'Markup'
  }
});
exports.contractSelectorMessages = contractSelectorMessages;